export default __webpack_public_path__ + "static/media/adi-kopolovich.80d15140.png";